import React from 'react';
import styles from './Spinner.module.css';

const Spinner = () =>{
	return (
    <div className={styles.Loader}>Loading...</div>
  )
};

export default Spinner;